import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { NewsroomClientMagazineTemplate } from "./client-magazine.templates";

export default {
    title: "Website/Partial Templates/Newsroom Blocks/Client Magazine Block",
    render: NewsroomClientMagazineTemplate.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        title: "Highlight Topic Lorem ipsum Dolor",
        icon: "globe",
        ctaText: "Mehr erfahren",
        ctaLink: "#",
    },
};

export const Default = {};
